import BackendService from './BackendService';

export default class LoginService {
  static getLogins(dealerId) {
    const params = { dealerId };
    return BackendService.get('/logins/all', { params });
  }

  static getLogin(loginId) {
    return BackendService.get(`/logins/${loginId}`);
  }

  static createLogin(login) {
    return BackendService.post('/logins', { body: login });
  }

  static updateLogin(login) {
    return BackendService.put(`/logins/${login.id}`, { body: login });
  }

  static verifyLoginById(loginId) {
    return BackendService.get(`/logins/verify/${loginId}`);
  }

  static verifyLogin(login) {
    return BackendService.post(`/logins/verify`, { body: login });
  }

  static deleteLogin(loginId) {
    return BackendService.delete(`/logins/${loginId}`);
  }
}
